import React, { useEffect, useState } from "react";
import "./TestimonialsStyles/Testimonials.scss";
import default_company from '../../assets/images/default-testimonial.webp'
import default_logo from '../../assets/images/default-logo.jpg'
import default_avatar from '../../assets/images/avatar.jpg'
const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([
    {
      testimonial: `Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.Default testimonial text goes here.`,
      name: "Default Name",
      designation: "Default Designation",
      company: "Default Company",
      company_logo: require("../../assets/images/schleuniger_logo.png"),
      image: require("../../assets/images/Klemens.png"),
    },
    {
      testimonial: `Default testimonial text goes here.`,
      name: "Default Name",
      designation: "Default Designation",
      company: "Default Company",
      company_logo: require("../../assets/images/schleuniger_logo.png"),
      image: require("../../assets/images/Klemens.png"),
    },
    {
      testimonial: `Default testimonial text goes here.`, // Duplicate first slide manually
      name: "Default Name",
      designation: "Default Designation",
      company: "Default Company",
      company_logo: require("../../assets/images/schleuniger_logo.png"),
      // image: require("../../assets/images/Klemens.png"),
    },
  ]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const getValidImageUrl = (url, defaultImage) => {
    const img = new Image();
    img.src = url;
    return img.complete && img.naturalHeight !== 0 ? url : defaultImage;
  };

  // Fetch testimonials and duplicate first slide at the end
  useEffect(() => {
    const apiUrl = "/getTestimonials.php";
  
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(apiUrl)
        const data = await response.json();
        const testimonialsArray = data?.testimonials;
        if (testimonialsArray && testimonialsArray.length > 0) {
          // duplicate first item for looping effect
          const duplicateFirst = [...testimonialsArray, testimonialsArray[0]];
          setTestimonials(duplicateFirst);
        } else {
          console.error("No testimonials found in API response, using default data.");
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };
  
    fetchTestimonials();
  }, []);
  

  // Move to the next slide (always forward)
  const moveToNextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  // Handle resetting to real first slide after reaching duplicate
  useEffect(() => {
    if (currentIndex === testimonials.length - 1) {
      setTimeout(() => {
        setIsTransitioning(false); // Remove animation
        setCurrentIndex(0); // Reset to real first
      }, 1000); // 1s for transition
    } else {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
      }, 2000); // 1s for normal transition reset
      return () => clearTimeout(timer);
    }
  }, [currentIndex, testimonials.length]);

 
  useEffect(() => {
    const autoSlideInterval = setInterval(() => {
      moveToNextSlide();
    }, 15000); 

    return () => clearInterval(autoSlideInterval);
  }, [testimonials.length]);

  return (
    <div className="testimonials-section">
      <div className="fullscreen section dark-section">
        <p className="section-title">Voice of Our Partners</p>
        {testimonials.length > 0 ? (
          <div className="testimonial-slider">
            <div className="row">
              <div className="col-1">
                {/* Manual next button */}
                <button className="testimonial-prev" onClick={moveToNextSlide}>
                  &lt;
                </button>
              </div>

              <div className="col-10 testimonial-slider-container">
                <div
                  className="testimonial-slider-track"
                  style={{
                    display: "flex",
                    transform: `translateX(-${currentIndex * 100}%)`,
                    transition: isTransitioning ? "transform 1s ease-in-out" : "none", // 1s transition
                  }}
                >
                  {testimonials.map((t, index) => (
                    <div
                      className="testimonial-slide"
                      key={index}
                      style={{
                        minWidth: "100%",
                        boxSizing: "border-box",
                      
                      }}
                    >
                      <div className="container">
                        <div className="testimonial-card compact-layout">
                         <div class="testimonial-body">
                           <p className="testimonial-text">“ {t.testimonial || "No testimonial available"} ”</p>
                          </div>
                         
                          <div className="testimonial-divider"></div>
                          <div className="testimonial-footer">
                            <div className="footer-left">
                              <img
                                src={getValidImageUrl(t.image ||default_avatar)}
                                alt={t.name || "Default Name"}
                                className="avatar"
                              />
                              <div className="testimonial-info">
                                <p className="testimonial-name">{t.name || "Default Name"}</p>
                                <p className="testimonial-role">{t.designation || "Default Designation"}</p>
                                <p className="testimonial-company">{t.company || "Default Company"}</p>
                              </div>
                            </div>
                            <img
                              src={t.company_logo || default_logo}
                              alt="company-logo"
                              className="company-logo"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        ) : (
          <p>Loading testimonials...</p>
        )}
      </div>
    </div>
  );
};

export default Testimonials;
